"use client"

import { useState } from "react"

import { texts } from "@/features/notifications/localization/texts"
import { LargePanel } from "@/features/notifications/TabletPanel"
import type { Notification } from "@/features/v2/notifications/types"

type DesktopNotificationsProps = {
  notifications: Notification[]
  trigger: React.ReactNode
}

export function DesktopNotifications({
  notifications,
  trigger
}: DesktopNotificationsProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        aria-expanded={open}
        aria-label={texts.triggerAlt}
        className="cursor-pointer border-0 bg-transparent p-0"
        onClick={() => setOpen((current) => !current)}
      >
        {trigger}
      </button>
      <LargePanel
        open={open}
        notifications={notifications}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
